/* eslint-disable max-len */
import { Stack, TextInput, Title } from '@mantine/core';
import { defineMessages, useIntl } from 'react-intl';
import cx from 'classnames';

import styles from '../ParentsDetails.module.scss';

import { useTeamMemberContext } from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/TeamMemberDetailsContext';
import sharedMessages from 'Components/utils/sharedMessages';

const headingId = 'team-member-parents-fathers-details-heading';

const FathersDetails = () => {
    const intl = useIntl();
    const { values } = useTeamMemberContext();
    const fathersData = values.parents?.find((parent) => parent.type === 'father');

    if (!fathersData) {
        return null;
    }

    return (
        <Stack gap="sm" aria-labelledby={headingId} className={cx(styles.container, styles.fatherHeader)}>
            <Title order={4} size="h5" id={headingId} className={styles.heading}>{intl.formatMessage(messages.heading)}</Title>
            <TextInput
                id="father-name-input-in-team-member"
                label={intl.formatMessage(sharedMessages.nameAndSurname)}
                value={fathersData.name}
                disabled
            />
            {fathersData.address && (
                <TextInput
                    id="father-address-input-in-team-member"
                    label={intl.formatMessage(sharedMessages.address)}
                    value={fathersData.address}
                    disabled
                />
            )}
            <TextInput
                id="father-email-input-in-team-member"
                label={intl.formatMessage(sharedMessages.email)}
                value={fathersData.email}
                disabled
            />
            {fathersData.phone && (
                <TextInput
                    id="father-name-phone-number-in-team-member"
                    label={intl.formatMessage(sharedMessages.phoneNumber)}
                    value={fathersData.phone}
                    disabled
                />
            )}
        </Stack>
    );
};

const basePath = 'src.Screens.Dashboard.Team.Components.TeamCellHandler.TeamInteractions.Interactions.Details.Components.TeamMemberParents.TeamMemberParents.Components.FathersDetails.FathersDetails';

const messages = defineMessages({
    heading: {
        id: `${basePath}.heading`,
        defaultMessage: 'Dane ojca',
    },
});

export default FathersDetails;
